'use strict';

import GoogleMap from "../map/GoogleMap";

export default class IHMozuFuruGoogleMap extends GoogleMap {
  constructor(mapEvents, popupFactory, placeType, options) {
    super(mapEvents, popupFactory, placeType, options)
    this.isChronological = false;
    this.interval = 0;
  }
  displayMarkers(request, places) {
    const facet = '年代区分';
    const era = ['4世紀後半', '5世紀前半', '5世紀後半'];
    let kofunNum = {[era[0]]: 0, [era[1]]: 0, [era[2]]: 0};
    let cnt = {[era[0]]: 0, [era[1]]: 0, [era[2]]: 0};
    let step = 0;
    let interval = 0;
    const additionalInterval = 1750;
    this.displayingPlaces = places;
    
    // 一時停止時の表示ステップ(=次に表示する年代区分)を取得
    if (this.isChronological) {
      let result = places.find( place => {
        return place.attributes[facet] === era[0];
      });
      if (!result) {
        result = places.find( place => {
          return place.attributes[facet] === era[1];
        });
        if (result) {
          step = 1;
        } else {
          step = 2;
        }
      }
    }
    
    for (let i = 0; i < places.length; i++) {
      const place = places[i];
      if (!place) {
        continue;
      }
  
      // 表示する年代区分・ステップ・再生モードによってタイムラグを設定
      if (this.isChronological) {
        if (place.attributes[facet] === era[0]) {
          interval = this.interval;
          kofunNum[era[0]]++;
        } else if (place.attributes[facet] === era[1]) {
          if (step === 1) {
            interval = this.interval;
          } else {
            interval = this.interval + additionalInterval;
          }
          kofunNum[era[1]]++;
        } else if (place.attributes[facet] === era[2]) {
          if (step === 1) {
            interval = this.interval + additionalInterval;
          } else if (step === 2) {
            interval = this.interval;
          } else {
            interval = this.interval + (additionalInterval * 2);
          }
          kofunNum[era[2]]++;
        }
      }
      
      this.timerID[i] = setTimeout(() => {
        cnt[place.attributes[facet]]++;
        if (this.isChronological && cnt[place.attributes[facet]] === kofunNum[place.attributes[facet]] ) {
          $(this).trigger('ihDisplayedOneGroupMarker', [places, place, marker, popup]);
        }
        // マーカーを生成して表示
        let marker = this.createMarker(place);
        // ポップアップを生成してリスナーに登録
        let popup = this.createMarkerPopup(place, marker);
        // マーカが1つ表示されるごとに発生するイベント
        $(this).trigger('ihDisplayedOneMarker', [places, place, marker, popup]);
        // 全マーカ表示後に発生するイベント
        if (i === places.length - 1 ) {
          $(this).trigger('ihDisplayedAllMarkers', [places, marker, popup]);
        }
      }, interval);
    }
  }
}



// WEBPACK FOOTER //
// ./map/js/ih/extend/IHMozuFuruGoogleMap.js